import { get, post, remove } from './api';
import routes from './end-points';

export const adminUserFundsApi = {
  initUserFunds: (userId) => get(routes.adminUserFunds.initUserFunds(userId)),
  toggleActive: (userId, fundId) => get(routes.adminUserFunds.toggleActive(userId, fundId)),
  delete: (userFundId) => remove(routes.adminUserFunds.deleteUserFund(userFundId)),
  saveChanges: (dto) => post(routes.adminUserFunds.applyUserFund, dto),
};
